module.exports = __webpack_public_path__ + "static/media/info_attention.32552c27.png";